const beige = { base: '#faf5f0ff' };

const blue = {
  base: '#3bb1cfff',
  darken1: '#288aa8ff',
  darken2: '#196682ff',
  darken3: '#0d445cff',
  darken4: '#072636ff',
  lighten1: '#6cc4dbff',
  lighten2: '#9dd8e7ff',
  lighten3: '#ceebf3ff',
  lighten4: '#ebf7faff',
  lighten5: '#f5fbfdff',
  lighten6: '#f9fdfeff',
};

const brown = {
  base: '#986e57ff',
  darken1: '#7a5846ff',
  darken2: '#5b4234ff',
  darken3: '#3d2c23ff',
  darken4: '#2e211aff',
  lighten1: '#ad8b79ff',
  lighten2: '#c1a89aff',
  lighten3: '#d6c5bcff',
  lighten4: '#e0d3cdff',
  lighten5: '#eae2ddff',
  lighten6: '#f5f0eeff',
};

const dashboard = {
  blue: '#b1d9eeff',
  green: '#84ddc6ff',
  orange: '#f8b7afff',
  pink: '#f6bdf8ff',
  purple: '#c2b4e9ff',
  red: '#ee9aaeff',
  yellow: '#ffda8aff',
};

const green = {
  base: '#32c6a0ff',
  darken1: '#20a185ff',
  darken2: '#127a67ff',
  darken3: '#085449ff',
  darken4: '#042e29ff',
  lighten1: '#5bd1b3ff',
  lighten2: '#84ddc6ff',
  lighten3: '#ade8d9ff',
  lighten4: '#d6f4ecff',
  lighten5: '#ebf9f5ff',
  lighten6: '#f9fdfcff',
};

const grey = {
  base: 'rgba(55, 53, 47, 0.6)',
  darken1: 'rgba(55, 53, 47, .7)',
  darken2: 'rgba(55, 53, 47, .8)',
  darken3: 'rgba(55, 53, 47, .9)',
  darken4: 'rgba(55, 53, 47, 1)',
  lighten1: 'rgba(55, 53, 47, .4)',
  lighten2: 'rgba(55, 53, 47, .3)',
  lighten3: 'rgba(55, 53, 47, .16)',
  lighten4: 'rgba(55, 53, 47, .09)',
  lighten5: 'rgba(55, 53, 47, .08)',
  lighten6: 'rgba(55, 53, 47, .06)',
  lighten7: 'rgba(55, 53, 47, .04)',
  lighten8: 'rgba(55, 53, 47, .02)',
};

const greyHex = {
  base: '#38363099',
  darken1: '#383630b3',
  darken2: '#383630cc',
  darken3: '#383630e6',
  darken4: '#383630ff',
  lighten1: '#38363066',
  lighten2: '#3836304d',
  lighten3: '#38363029',
  lighten4: '#38363017',
  lighten5: '#38363014',
  lighten6: '#3836300f',
  lighten7: '#3836300a',
  lighten8: '#38363005',
};

const orange = {
  base: '#fa541cff',
  darken1: '#d4380dff',
  darken2: '#ad2102ff',
  darken3: '#871400ff',
  darken4: '#610b00ff',
  lighten1: '#ff7a45ff',
  lighten2: '#ff9c6eff',
  lighten3: '#ffbb96ff',
  lighten4: '#ffd8bfff',
  lighten5: '#fff2e8ff',
  lighten6: '#fffbf8ff',
};

const pink = {
  base: '#c14c8aff',
  darken1: '#9a3d6eff',
  darken2: '#742e53ff',
  darken3: '#4d1e37ff',
  darken4: '#3a1729ff',
  lighten1: '#cd70a1ff',
  lighten2: '#da94b9ff',
  lighten3: '#e6b7d0ff',
  lighten4: '#ecc9dcff',
  lighten5: '#f3dbe8ff',
  lighten6: '#f3dbe8ff',
};

const purple = {
  base: '#9065b0ff',
  darken1: '#73518dff',
  darken2: '#563d6aff',
  darken3: '#3a2846ff',
  darken4: '#2b1e35ff',
  lighten1: '#a684c0ff',
  lighten2: '#bca3d0ff',
  lighten3: '#d3c1dfff',
  lighten4: '#ded1e7ff',
  lighten5: '#e9e0efff',
  lighten6: '#f4f0f7ff',
};

const red = {
  base: '#da4f64ff',
  darken1: '#ca4a60ff',
  darken2: '#b4445bff',
  darken3: '#9e3f56ff',
  darken4: '#7b344cff',
  lighten1: '#e05e78ff',
  lighten2: '#e7758fff',
  lighten3: '#ee9aaeff',
  lighten4: '#f5c0cdff',
  lighten5: '#fae6ebff',
  lighten6: '#fef7f9ff',
};

const shades = {
  black: '#000000ff',
  transparent: 'transparent',
  white: '#ffffffff',
};

const yellow = {
  base: '#fdb237ff',
  darken1: '#d68c24ff',
  darken2: '#b06a15ff',
  darken3: '#8a4c0aff',
  darken4: '#633306ff',
  lighten1: '#ffc861ff',
  lighten2: '#ffda8aff',
  lighten3: '#ffe9b3ff',
  lighten4: '#fff6dbff',
  lighten5: '#fffcf0ff',
  lighten6: '#fffefbff',
};

export default {
  beige,
  blue,
  brown,
  dashboard,
  green,
  grey,
  greyHex,
  orange,
  pink,
  purple,
  red,
  shades,
  yellow,
};
